<template>
	<form class="comment">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-lg-4">
					<input v-if="!anonymous" :key="1" class="comment__input comment__input--name" type="text" :placeholder="$t('judge.name')">
					<input v-if="anonymous" :key="2" class="comment__input comment__input--name" type="text" placeholder="Anonymous" value="Anonymous" disabled>

					<label class="filter__label">
						<input v-model="anonymous" class="filter__input" type="checkbox">
						<span class="filter__checkbox">
						<span class="filter__checkbox--bg"></span>
					</span>
						{{$t('judge.anonymous')}}
					</label>
				</div>
				<div class="col-sm-12 col-lg-4">
					<div class="filter__wrapper">
						<input class="filter comment__input comment__input--breed"
							   type="text"
							   :class="{open: 'open' === showList, close: 'open' !== showList}"
							   @click="updateShowList('open')"
							   :placeholder="$t('judge.breed')"
							   v-model="searchByBreed"
						>
						<ul v-show="'open' === showList"
							class="filter__list"
						>
							<li class="filter__list-item" @click="removeBreed()">{{$t('judge.remove')}}</li>
							<li class="filter__list-item"
								v-for="breed in breedsList"
								@click="selectBreed(breed)"
								:class="{'filter__list-item--active': searchByBreed === breed.name}"
							>
								{{breed.name}}
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<textarea class="comment__msg" name="" id="" :placeholder="$t('judge.opinion')"></textarea>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-5">
					<div class="comment__stars">
						<span class="comment__stars-label">{{$t('judge.rate')}}</span>
						<div class="comment__stars--wrapper">
							<div v-for="i in 6" @click="setScore(i)" class="comment__star">
								<img v-if="i > score" src="/static/img/empty.svg" alt="">
								<img v-if="i <= score" src="/static/img/star-big.svg" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-4 col-4--flex">
					<button @click="addComment($event)" class="comment__btn">{{$t('judge.button')}}</button>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
	import axios from 'axios'
	export default {
		components: {
		},
		data () {
			return {
				show: false,
				score: 0,
				anonymous: false,
				showList: '',
				breeds: [],
				searchByBreed: '',
				activeBreed: ''
			}
		},
		methods: {
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			selectBreed (breed) {
				this.searchByBreed = breed.name
				this.activeBreed = breed.id
				this.showList = ''
			},
			removeBreed () {
				this.searchByBreed = ''
			},
			setScore (score) {
				if (this.score === score) {
					this.score = 0
				} else {
					this.score = score
				}
			},
			addComment (e) {
				e.preventDefault()
				const firstName = document.querySelector('.comment__input--name').value
				const comment = document.querySelector('.comment__msg').value
				let data = {
					judge: this.$route.params.id,
					first_name: firstName,
					breed: this.activeBreed,
					comment,
					score: this.score
				}
				axios.post(`/api/judges/${ this.$route.params.id }/comments/`, data, {
					headers: {
						'accept': 'application/json'
					}
				})
					.then(resp => {
						this.$emit('addComment')
						document.querySelector('.comment__input--name').value = ''
						document.querySelector('.comment__msg').value = ''
						document.querySelector('.comment__input--breed').value = ''
						this.score = 0
						this.anonymous = false
						this.searchByBreed = ''
						this.activeBreed = ''
					})
					.catch(err => {
						console.log(err)
					})
			},
			fetchBreeds () {
				axios.get('/api/dogs/subgroup/autocomplete/', {
				})
					.then(response => {
						this.breeds = response.data
					})
					.catch(error => {
						console.error(error)
					})
			}
		},
		computed: {
			breedsList () {
				const inputTest = breed => {
					const regExp = new RegExp('^' + this.searchByBreed, 'i')
					return regExp.test(breed.name)
				}
				return this.breeds.filter(inputTest)
			}
		},
		created () {
			this.fetchBreeds()
			window.addEventListener('click', this.closeFlitersLists)
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";

	.comment {
		padding-top: 15px;
		background-color: #fff;

		&__input {
			width: 100%;
			height: 65px;
			background-color: $gray-input;
			padding-left: 25px;
			border: none;
			outline: none;
			margin-bottom: 20px;
		}

		&__msg {
			width: 100%;
			height: 130px;
			resize: none;
			background-color: $gray-input;
			border: none;
			padding: 25px;
			margin-bottom: 40px;
			outline: none;
		}
		&__stars {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-bottom: 40px;
			&--wrapper {
				display: flex;
			}
			img {
				cursor: pointer;
				margin-right: 10px;
			}
		}
		&__stars-label {
			margin-right: 25px;
			font-size: 16px;
		}
		&__btn {
			cursor: pointer;
			width: 100%;
			max-width: 295px;
			height: 65px;
			background-color: $black;
			color: #fff;
			font-family: $lato-bold;
			font-size: 16px;
			text-transform: uppercase;
			border: none;
			outline: none;
			margin-bottom: 30px;
			letter-spacing: 0.05em;
		}
	}

	.col-4 {
		&--flex {
			display: flex;
			justify-content: flex-start;
		}
	}

	.filter {
		margin-bottom: 0px;
		&__wrapper {
			position: relative;
		}
		&__list {
			z-index: 5;
			position: absolute;
			width: 100%;
			/*max-width: 354px;*/
			max-height: 210px;
			overflow: hidden;
			overflow-y: scroll;
			list-style: none;
			background-color: $brown-light;
			padding: 15px 0;
			margin: 0;
			&--long {
				max-width: 259.5px;
			}
		}
		&__list-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 99%;
			padding-left: 15px;
			min-height: 30px;
			cursor: pointer;
			font-family: $lato;
			font-size: 13px;
			&:hover, &--active {
				background-color: #fff;
			}
		}
		&__input {
			background: transparent;
			border: none;
			outline: none;
			font-style: italic;
		}
		&__label {
			display: flex;
			align-items: center;
			position: relative;
			cursor: pointer;
			width: 100%;
			text-align: left;
			font-family: $lato;
			font-size: 14px;
			-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;
			margin-bottom: 20px;
			input {
				position: absolute;
				opacity: 0;
				cursor: pointer;
			}
			input:checked + .filter__checkbox > .filter__checkbox--bg {
				background-color: $black;
			}
		}
		&__checkbox {
			position: relative;
			height: 16px;
			width: 16px;
			border: 2px solid $black;
			margin-right: 15px;
			&--bg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				display: block;
				width: 8px;
				height: 8px;
			}
		}
	}

	.filter__list::-webkit-scrollbar {
		width: 3px;
	}

	.filter__list::-webkit-scrollbar-thumb {
		background-color: $brown;
	}

	@media (max-width: 991.98px) {
		.comment {
			&__stars-label {
				margin-bottom: 15px;
			}
			&__msg {
				margin-top: 20px;
			}
			&__stars {
				flex-flow: column;
				align-items: flex-start;
				img {
					width: 39px;
					height: 37px;
				}
			}
		}
		.filter {
			&__label {
				/*margin-top: 20px;*/
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Judge/Details/AddCommentComponent.vue